import { StudiesDataResponse, QueryParamListBase } from '@shared/models';

export interface StudiesListQueryParam
  extends StudiesDataResponse,
    QueryParamListBase {}
